export default "__VITE_ASSET__527cc55c__"